import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const InfoCircled = forwardRef(({ size = 'medium', fill = 'currentColor', innerFill = 'transparent', ...props }, ref) => {
    const innerFillValue = innerFill === 'transparent' ? 'transparent' : 'var(--cb-icon-inner-color-contrast)';
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { fillRule: "evenodd", d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10M9.116 9.116A1.25 1.25 0 0 0 8.75 10v3.75a1.25 1.25 0 0 0 2.5 0V10a1.25 1.25 0 0 0-2.134-.884m0-3.75a1.25 1.25 0 1 0 1.768 1.768 1.25 1.25 0 0 0-1.768-1.768" }), _jsx("path", { d: "M9.116 9.116A1.25 1.25 0 0 0 8.75 10v3.75a1.25 1.25 0 0 0 2.5 0V10a1.25 1.25 0 0 0-2.134-.884m0-3.75a1.25 1.25 0 1 0 1.768 1.768 1.25 1.25 0 0 0-1.768-1.768", fill: innerFillValue })] }));
});
InfoCircled.displayName = 'InfoCircled';
InfoCircled.__iconComponentType = 'contrast';
export default InfoCircled;
//# sourceMappingURL=InfoCircled.js.map